// 语言包
const DEFAULT_LANG = 'cn'; // 默认语言
const SERVER_LANG = window.lang_env || DEFAULT_LANG; // 服务端语言
const SERVER_LANG_URL = window._lang || ''; // 服务端语言路由

const LANG = {
  en: 'en-us',
  cn: 'zh-cn'
};
// 选项
const OPTIONS = {
  0: 'A',
  1: 'B',
  2: 'C',
  3: 'D',
  4: 'E',
  5: 'F',
  6: 'G',
  7: 'H',
  8: 'I',
  9: 'J'
};
const QUESTION_TYPE = {
  1: '单选题',
  2: '多选题',
  3: '选答题'
};
// url_code 状态码
const URL_CODE_TIPS = {
  1: '激活成功',
  2: '修改密码成功',
  3: '邮箱绑定成功',
  90000: '未知原因激活失败',
  90001: '激活链接已失效',
  90002: '无效的激活链接'
};
export {
  DEFAULT_LANG,
  LANG,
  SERVER_LANG,
  SERVER_LANG_URL,
  OPTIONS,
  URL_CODE_TIPS,
  QUESTION_TYPE
};
